import { createPortal } from 'react-dom';
import { ICommentsAndObservations } from '../../../../types/global';
import BordCommentsAndObservations from '../../../../components/BordComentsAndObservations/BordComentsAndObservations';
import { IResponsibleUserData } from '../../../../types/responsibleUser.types';
import './CheckOrAddCommentsModal.scss';

const CheckOrAddCommentsModal = ({
  closeModal,
  orderComments,
  handleSubmitComments,
  loading,
  responsibleUsers = [],
  organizationId
}: {
  closeModal: () => void;
  orderComments?: ICommentsAndObservations[];
  handleSubmitComments?: (comment: ICommentsAndObservations) => Promise<void>;
  loading: boolean;
  responsibleUsers?: IResponsibleUserData[];
  organizationId?: number;
}) => {
  return (
    <>
      {createPortal(
        <div className="checkOrAddCommentsModal">
          <BordCommentsAndObservations
            comments={orderComments}
            closeModalCallback={closeModal}
            handleSubmitComments={handleSubmitComments}
            loading={loading}
            responsibleUsers={responsibleUsers}
            organizationId={organizationId}
          />
        </div>,
        document.body
      )}
    </>
  );
};

export default CheckOrAddCommentsModal;
